import { HttpClient , HttpParams  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FinancialManagerService {
  constructor(private http: HttpClient) { }

  getAllPayments(): Observable<any> {
    return this.http.get(environment.Server_URL + '/pyment/index');
  }
  getPayments(perpage: any, page: any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    return this.http.post(`${environment.Server_URL}/pyment/index?page=${page}`, body);
  }
  complated(id: any): Observable<any> {
    const body = new FormData();
    body.append('complated', "1");
    return this.http.post(environment.Server_URL + '/update-pyment/' + id, body);
  }
  getUserPayement(id: any, page: any): Observable<any> {
    const body = new FormData();
    body.append('user_id', id);
    return this.http.post(`${environment.Server_URL}/get-pyment/user?page=${page}`, body);
  }
  addexpenses(formData: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/outbalances`, formData);
  }
  addRevenue(formData: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/imbalances`, formData);
  }

  getRevenues(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/imbalances`);
  }

  getexpenses(): Observable<any> {
    return this.http.get(`${environment.Server_URL}/outbalances`);
  }
deleteRev(id: any, deletedBy: string): Observable<any> {
  return this.http.post(`${environment.Server_URL}/imbalances/${id}/delete`, {
    deleted_by: deletedBy
  });
}

deleteEx(id: any, deletedBy: string): Observable<any> {
  return this.http.post(`${environment.Server_URL}/outbalances/${id}/delete`, {
    deleted_by: deletedBy
  });
}

   // ✅ Get imbalances by specific date (YYYY-MM-DD)
  getInbalanceByDate(date: string): Observable<any> {
    const params = new HttpParams().set('date', date);
    return this.http.get(`${environment.Server_URL}/imbalances/by-date`, { params });
  }

  // ✅ Get imbalances by specific month (YYYY-MM)
  getInbalanceByMonth(month: string): Observable<any> {
    const params = new HttpParams().set('month', month);
    return this.http.get(`${environment.Server_URL}/imbalances/by-month`, { params });
  }
    // ✅ Get Outbalances by specific day
  getOutbalanceByDate(date: string): Observable<any> {
    const params = new HttpParams().set('date', date);
    return this.http.get(`${environment.Server_URL}/outbalances/by-date`, { params });
  }

  // ✅ Get Outbalances by specific month
  getOutbalanceByMonth(month: string): Observable<any> {
    const params = new HttpParams().set('month', month);
    return this.http.get(`${environment.Server_URL}/outbalances/by-month`, { params });
  }
getEmployeeBalances(employeeId: number, month?: string , date?: string): Observable<any> {
  let params = new HttpParams().set('employee_id', employeeId.toString());

  if (date) {
    params = params.set('date', String(date)); // بصيغة YYYY-MM-DD
  } else if (month) {
    params = params.set('month', String(month)); // بصيغة YYYY-MM
  }

  return this.http.get(`${environment.Server_URL}/employee-balances`, { params });
}
  getArchivedBalances() {
    return this.http.get<any>(`${environment.Server_URL}/balances/archived`);
  }
  searchBalances(keyword: string): Observable<any> {
  const params = new HttpParams().set('keyword', keyword);
  return this.http.get(`${environment.Server_URL}/balances/search`, { params });
}
editAmount(id: number, amount: number, type: number, note?: string): Observable<any> {
  const body = { id, amount, type, note };
  return this.http.post(`${environment.Server_URL}/balances/edit-amount`, body);
}


}
